import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash';
import 'trade-in-360/components/InstantEstimateWrapper/Components/ConfirmationMessage/ConfirmationMessage.scss';
import ActionButton from '../ActionButton/ActionButton.jsx';

const ConfirmationMessage = ({ title, description, closeText, onClose, children }) => {
    return (
        <div className="confirmation-message">
            <div className="confirmation-message-header">
                <icon className="icon-radio-button-on" />
                <h3 className="confirmation-message-header--title">{title}</h3>
            </div>
            <p className="confirmation-message--desc">{description}</p>
            <div className="vehicle-buttons-container">
                <div className="vehicle-buttons">
                    {closeText &&
                        onClose && (
                            <ActionButton noArrow noPrefix onClick={onClose}>
                                {closeText}
                            </ActionButton>
                        )}
                    {children}
                </div>
            </div>
        </div>
    );
};

ConfirmationMessage.defaultProps = {
    closeText: null,
    onClose: noop,
    children: null,
};

ConfirmationMessage.propTypes = {
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    closeText: PropTypes.string,
    onClose: PropTypes.func,
    children: PropTypes.element,
};

ConfirmationMessage.displayName = 'ConfirmationMessage';

export default ConfirmationMessage;
